class OrderManagementActionsController {
    constructor(moveFocus) {
        this.moveFocus = moveFocus;
    }

    onActionClick() {
        this.moveFocus('#body-container');
        this.itemCtrl.setView('DETAILS');
    }
}

const orderManagementActionsComponentDefinition = {
    bindings: {
        order: '<',
    },
    require: {
        itemCtrl: '^wowOrderManagementItem',
    },
    controller: ['MoveFocus', OrderManagementActionsController],
    template: require('./order-management-actions.component.html').trim(),
};

module.exports = {
    OrderManagementActionsController,
    orderManagementActionsComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/ordermanagement/order-management-actions.component.js